import styled from 'styled-components';
import { config } from '../../../../../../../components/dashboards/config';

export default styled.div`
  width: -webkit-fill-available;
  height: 100%;
  padding: 0 ${config.PADDING}px ${config.PADDING}px ${config.PADDING}px;
  display: flex;
  flex-direction: column; 
  
  .ant-table table {
    width: -webkit-fill-available;
  }

  .tasks-span {
    font-weight: 700;
    cursor: pointer;
  }

  .ant-table-placeholder {
    display: none;
  }

  .ant-list-bordered {
    border-left: 0px;
    border-right: 0px;
  }
  .even-row {
    background: #FAFAFA;
  }
  .expanded-container {
    display: flex;
    width: 100%;

    .main {
      flex: 1;
    }
  }

  .ant-spin-container {
    display: flex;
    flex-direction: column;
    

    .ant-table {
      flex: 1;
    }

    .ant-pagination {
      display: flex;
      justify-content: flex-end;
    }
  }

  .ant-tag {
    margin-right: 0px;
  }

  &.has-data {
    .ant-table-wrapper, .ant-spin-nested-loading, .ant-spin-container {
      height: 100%;
    }
  }

  .ant-table {
    td { color: #595959; }

    .ant-table-tbody .expanded-row {
      background: #E6F7FF;
      

      td {
        border-bottom: 1px solid var(--mmt-primary-70) !important;
      }

      td:nth-child(5), td:nth-child(6) {
        background: white;
        border-top: 1px solid var(--mmt-primary-70);
        border-bottom: 0px !important;
      }

      td:nth-child(6) {
        border-right: 1px solid var(--mmt-primary-70);
      }

      td:nth-child(5) {
        border-left: 1px solid var(--mmt-primary-70);
      }
    }

    tr.ant-table-expanded-row > td {
      border-left: 1px solid var(--mmt-primary-70);
      border-right: 1px solid var(--mmt-primary-70);
      border-bottom: 1px solid var(--mmt-primary-70) !important;
    }

    tr.ant-table-expanded-row > td, tr.ant-table-expanded-row:hover > td {
      background: white;
    }
    
    tr.ant-table-row-level-0:hover > td, td.ant-table-column-sort {
      background: unset;
    }
  }

  .expandedrow {
    transition: .4s max-height; 
    overflow: hidden;
  }
`;
